var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EnhancedDocumentHubV2 from './DocumentHub';
import { createDocSession } from '../../services/apiClient';
import { useAuth } from '../../context/AuthContext';
import { routes } from '../../config/routes';
var EnhancedDocumentAnalysis = function () {
    var documentId = useParams().documentId;
    var navigate = useNavigate();
    var currentUser = useAuth().currentUser;
    // Debug logging to track URL changes
    console.log('[EnhancedDocumentAnalysis] Component rendered', {
        documentId: documentId,
        currentUser: !!currentUser,
        url: window.location.pathname
    });
    // Handle legacy demo URLs by redirecting to create a new session
    useEffect(function () {
        console.log('[EnhancedDocumentAnalysis] useEffect triggered', {
            documentId: documentId,
            isDemoDoc: documentId === 'demo-doc' || (documentId === null || documentId === void 0 ? void 0 : documentId.startsWith('demo-'))
        });
        if (documentId === 'demo-doc' || (documentId === null || documentId === void 0 ? void 0 : documentId.startsWith('demo-'))) {
            handleCreateNewSession();
        }
    }, [documentId]);
    var handleCreateNewSession = function () { return __awaiter(void 0, void 0, void 0, function () {
        var session, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!currentUser) {
                        navigate('/documents');
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createDocSession({
                            title: 'Enhanced Analysis Session'
                        })];
                case 2:
                    session = (_a.sent()).session;
                    navigate(routes.documentAnalysis(session.id), { replace: true });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Failed to create new session:', error_1);
                    navigate('/documents', { replace: true });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Don't render anything if we're handling a demo URL
    if (documentId === 'demo-doc' || (documentId === null || documentId === void 0 ? void 0 : documentId.startsWith('demo-'))) {
        return null;
    }
    // Use the session ID from URL params directly - ensure it's stable
    if (!documentId) {
        console.error('[EnhancedDocumentAnalysis] No documentId in URL params');
        navigate('/documents', { replace: true });
        return null;
    }
    var sessionId = documentId;
    console.log('[EnhancedDocumentAnalysis] Rendering with sessionId', {
        documentId: documentId,
        sessionId: sessionId
    });
    return (_jsx(EnhancedDocumentHubV2, { sessionId: sessionId }));
};
export default EnhancedDocumentAnalysis;
